<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "MarketingExecutive",

  metaInfo: { title: "Marketing Executive" },

  extends: View,

  mixins: [LoadSections(["hero-alt", "marketing-executive", "info"])],

  props: {
    id: {
      type: String,
      default: "marketingexecutive"
    }
  }
};
</script>
